import React, { useState } from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import moment from "moment";
import { DATE_FORMATS } from "../../../utils/Constant";
import useEmpresa from "../../../hooks/useEmpresa";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import Tooltip from "../../../components/Common/Tooltip";
import { EyeOutlined } from "@ant-design/icons";
import Pagination from "../../../components/CustomTable/Pagination";
import { useHistory } from "react-router-dom";

const BusquedaCierresCuentasTabla = (props) => {
  const { formConsultaCierresCuentasData } = props;
  const empresa = useEmpresa();
  const history = useHistory();
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const { prestador } = props?.authUserData;

  const columnasCierresCuentas = [
    {
      key: "secuenciaReclamacion",
      title: "No. de reclamo",
      dataIndex: "secuenciaReclamacion",
    },
    {
      key: "nombreAfiliado",
      title: "Nombre del afiliado",
      dataIndex: "nombreAfiliado",
    },
    {
      key: "numeroPlastico",
      title: "No. de carnet",
      dataIndex: "numeroPlastico",
    },
    {
      key: "fechaIngreso",
      title: "Fecha de servicio",
      dataIndex: "fechaIngreso",
      render: (text, record) =>
        moment(record.fechaIngreso).format(DATE_FORMATS.middledash_dmy),
    },
    {
      key: "fechaSalida",
      title: "Fecha de salida",
      dataIndex: "fechaSalida",
      render: (text, record) =>
        moment(record.fechaSalida).format(DATE_FORMATS.middledash_dmy),
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Tooltip text="Voucher">
          <EyeOutlined
            style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
            onClick={() => {
              onPressVoucher(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];

  const buscarCierresCuentas = (pagina) => {
    const {
      fechaInicio,
      fechaFin,
      numeroReclamacion,
      numeroAfiliado,
      fechaServicio,
      fechaSalida,
    } = formConsultaCierresCuentasData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaInicio, fechaFin })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (moment(fechaInicio).isAfter(fechaFin)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    if (mensajeValidacion) {
      props.formConsultaCierresCuentas({
        ...formConsultaCierresCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: mensajeValidacion,
          onConfirm: () => {
            props.formConsultaCierresCuentas({
              ...formConsultaCierresCuentasData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      });
      return;
    }

    props.consultarCierresCuentas({
      formConsultaCierresCuentasData: formConsultaCierresCuentasData,
      formHandler: props.formConsultaCierresCuentas,
      compania: empresa?.CODIGO,
      reclamante: prestador?.codigo,
      fechaInicio,
      fechaFin,
      numeroReclamacion,
      numeroAfiliado,
      fechaServicio,
      fechaSalida,
      pagina: pagina,
      tamanoPagina: itemsPerPage,
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    buscarCierresCuentas(page);
  };

  const onPressVoucher = (record) => {
    history.push({
      pathname: "/detalle-cierre-cuenta",
      state: {
        numeroIngreso: record?.secuencial,
        anioIngreso: record?.ano,
      },
    });
  };

  return (
    <>
      <Section>
        <CustomTable
          columns={columnasCierresCuentas}
          dataSource={
            formConsultaCierresCuentasData?.dataCierres?.cierreCuentas || []
          }
          showPagination={false}
          pageSize={10}
          width={"200%"}
        />
      </Section>
      <CustomSeparator height={"20px"} />
      <Section>
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={
            formConsultaCierresCuentasData?.dataCierres?.cantidadRegistros || 0
          }
          onPageChange={handlePageChange}
        />
      </Section>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formConsultaCierresCuentasData: state.ingreso.formConsultaCierresCuentasData,
  formConsultaCierresCuentasLoading:
    state.ingreso.formConsultaCierresCuentasLoading,

  consultarCierresCuentasLoading: state.ingreso.consultarCierresCuentasLoading,
});

const mapDispatchToProps = {
  formConsultaCierresCuentas: IngresoActions.formConsultaCierresCuentas,
  consultarCierresCuentas: IngresoActions.consultarCierresCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaCierresCuentasTabla);
